import { locale as enUS } from './i18n/en-US';
import { locale as daDK } from './i18n/da-DK';
import { locale as svSE } from './i18n/sv-SE';
import { locale as viVN } from './i18n/vi-VN';
import { locale as thTH } from './i18n/th-TH';

export const locales = [enUS, daDK, svSE, viVN, thTH];
